import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { Box, Drawer, IconButton } from '@mui/material';
// mock
// hooks
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { APP_NAV_ITEMS } from '../../../utils/conts';
import useResponsive from '../../../hooks/useResponsive';
import { useAppContext } from '../../../contexts/AppContext';
// components
import Logo from '../../../components/logo';
import Scrollbar from '../../../components/scrollbar';
import NavSection from '../../../components/nav-section';

// ----------------------------------------------------------------------

const NAV_WIDTH = 280;
const COLLAPSED_WIDTH = 64;

// ----------------------------------------------------------------------

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
  isCollapsed: PropTypes.bool,
  toggleSidebar: PropTypes.func,
};

// ----------------------------------------------------------------------

export default function Nav({ openNav, onCloseNav, toggleSidebar, isCollapsed }) {
  const { pathname } = useLocation();
  const [navConfig, setNavConfig] = useState([]);
  const accessToken = localStorage.getItem('access');
  const { selectedApp } = useAppContext();

  const isDesktop = useResponsive('up', 'lg');

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }

    const navItems = APP_NAV_ITEMS[selectedApp] || APP_NAV_ITEMS.admin;
    setNavConfig(navItems);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, accessToken, selectedApp]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: '100%',
        '& .simplebar-content': {
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          overflowX: 'hidden',
          width: isCollapsed ? COLLAPSED_WIDTH : NAV_WIDTH,
        },
        '& .simplebar-content > *': {
          maxWidth: isCollapsed ? COLLAPSED_WIDTH : NAV_WIDTH,
        },
        '& .simplebar-wrapper': {
          height: '100%',
        },
        '& .simplebar-mask': {
          height: '100%',
        },
        '& .simplebar-offset': {
          height: '100%',
        },
      }}
    >
      <Box sx={{ px: 2.5, py: 3, display: 'inline-flex' }}>
        <Logo type={isCollapsed ? 'mobile' : 'desktop'} />
      </Box>

      <NavSection data={navConfig} isCollapsed={isCollapsed} />

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: isCollapsed ? COLLAPSED_WIDTH : NAV_WIDTH },
      }}
    >
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: isCollapsed ? COLLAPSED_WIDTH : NAV_WIDTH,
              bgcolor: '#F4F8FF',
              borderRightStyle: 'dashed',
              height: '100vh',
              overflow: 'hidden',
              transition: (theme) =>
                theme.transitions.create('width', {
                  easing: theme.transitions.easing.sharp,
                  duration: theme.transitions.duration.enteringScreen,
                }),
            },
          }}
        >
          {renderContent}
          <IconButton onClick={toggleSidebar} sx={{ display: { xs: 'none', lg: 'block' }, width: 'max-content' }}>
            {isCollapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: { width: NAV_WIDTH },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
